import { createAction } from "redux-actions";

export const getReceivers = createAction("GET_RECEIVERS");
export const setReceivers = createAction("SET_RECEIVERS");
